import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { PartsService } from 'src/app/services/parts.service';
import { MapInformationService } from 'src/app/services/map-information.service';
import { ContactService } from 'src/app/services/contact.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { AppConfigService } from 'src/app/app-config.service.service';
import { TranslateService } from '@ngx-translate/core';
import CustomStore from 'devextreme/data/custom_store';
@Component({
  selector: 'app-new-part',
  templateUrl: './new-part.component.html',
  styleUrls: ['./new-part.component.scss']
})

export class NewPartComponent implements OnInit {

  @Input() popupNewPart = false;
  @Output() onmodalhidden = new EventEmitter<any>();
  @Output() onsubmit = new EventEmitter<any>();
  @Input() formDataParts;
  @Input() master:boolean = false;
  heightPopup = '550'

  /** Mismo origen que edit-parts (Get_VendorsAllByName / Get_VendorsByIDCE). */
  manufacturedByStore: CustomStore;

  newPart: FormGroup;

  parttype: any = [];
  disableproductinput: boolean = true;
  //Formats
  settings: any = {};
  errorDescription= false;
  popupAPL:boolean=false

  popupPartsSearch:boolean = false

  infoConn = {
    id: 0,
    token: '',
  };
  popupImportFromMaster:boolean = false
  infoComponent = { method: 'Get_PartsMaster', component: 'AppParts', methodSave: "Import_PartsMaster" }


  constructor(
    private route: Router,
    activatedRoute: ActivatedRoute,
    private partService: PartsService,
    private toast: ToastService,
    private appconfig: AppConfigService,
    private MapInformationService: MapInformationService,
    private contactService: ContactService,
    private translate:TranslateService
  ) {

    this.settings.dateFormat = this.appconfig.dateFormat;
    this.settings.moneyFormat = this.appconfig.moneyFormat;

    this.newPart = new FormGroup({
      partnumber: new FormControl({value: '', disabled: false},[]),
      parttypeid: new FormControl({value: '', disabled: false},[]),
      manufacturedid: new FormControl({ value: null, disabled: false }, []),
      defaultvendorid: new FormControl({ value: null, disabled: false }, []),
      stdcost: new FormControl({value: '', disabled: false},[]),
      active: new FormControl({value: true, disabled: false},[]),
      taxable: new FormControl({value: '', disabled: false},[]),
      partdescription: new FormControl({value: '', disabled: false},[]),
      createasproduct: new FormControl({value: false, disabled: false},[]),
      price: new FormControl({value: '', disabled: false},[]),
      productdetails: new FormControl({value: '', disabled: false},[]),
      id:  new FormControl(0,[]),
    })
  }

  ngOnInit() {
    if(this.master) this.heightPopup = '420'
    else this.heightPopup = '620'
    console.log("🚀 ~ NewPartComponent ~ this.heightPopup:", this.heightPopup)

    this.initManufacturedByStore();
    this.initForm();
    this.getToken();
  }

  getToken() {
    const info = {
      method: 'Get_ConnectedVendor',
      mastervendorid: 1001,
    };
    this.MapInformationService.MethodCallApiFlex(info).subscribe((resp: any) => {
      this.infoConn.id = resp[0].MASTERVENDORID;
      this.infoConn.token = resp[0].MASTERVENDORCONNECTIONTOKEN;
    });
  }

  initManufacturedByStore() {
    const mythis = this;
    this.manufacturedByStore = new CustomStore({
      key: 'ID',
      load: (loadOptions: any) => {
        let search = loadOptions.searchValue;
        if (search === '' || search === undefined || search === null) {
          search = ' ';
        }
        return mythis.contactService
          .Get_VendorsAllByName(search)
          .toPromise()
          .then((data: any) => data)
          .catch(() => {
            throw new Error('Data Loading Error');
          });
      },
      byKey: (key: any) => {
        if (key === null || key === undefined || key === '') {
          return Promise.resolve(null);
        }
        return mythis.contactService
          .Get_VendorsByIDCE(key)
          .toPromise()
          .then((data: any) => {
            if (Array.isArray(data) && data.length) {
              const d = data[0];
              return {
                ...d,
                Vendor_Name: d.Vendor_Name != null ? d.Vendor_Name : d.NAME,
              };
            }
            return null;
          })
          .catch(() => {
            throw new Error('Data Loading Error');
          });
      },
    });
  }

  dataManufactured = []

  initForm(){

    if(!this.master && this.formDataParts != undefined){

      this.newPart = new FormGroup({
        partnumber: new FormControl({value:this.formDataParts.partnumber, disabled: false},[]),
        parttypeid: new FormControl({value:this.formDataParts.parttypeid, disabled: false},[]),
        manufacturedid: new FormControl({value:this.formDataParts.manufacturedid != null ? this.formDataParts.manufacturedid : null, disabled: false},[]),
        defaultvendorid: new FormControl({value:this.formDataParts.defaultvendorid != null ? this.formDataParts.defaultvendorid : null, disabled: false},[]),
        stdcost: new FormControl({value:this.formDataParts.stdcost, disabled: false},[]),
        active: new FormControl({value:this.formDataParts.active == undefined ? false:true, disabled: false},[]),
        taxable: new FormControl({value:this.formDataParts.taxable == undefined ? false:true, disabled: false},[]),
        partdescription: new FormControl({value:this.formDataParts.partdescription, disabled: false},[]),
        createasproduct: new FormControl({value:this.formDataParts.createasproduct, disabled: false},[]),
        price: new FormControl({value:this.formDataParts.price, disabled: false},[]),
        productdetails: new FormControl({value:this.formDataParts.productdetails, disabled: false},[]),
        id:  new FormControl(this.formDataParts.id,[])
      })
      
    } else {

      this.newPart = new FormGroup({
        partnumber: new FormControl({value: '', disabled: false},[]),
        parttypeid: new FormControl({value: '', disabled: false},[]),
        manufacturedid: new FormControl({ value: null, disabled: false }, []),
        defaultvendorid: new FormControl({ value: null, disabled: false }, []),
        stdcost: new FormControl({value: '', disabled: false},[]),
        active: new FormControl({value: true, disabled: false},[]),
        taxable: new FormControl({value: '', disabled: false},[]),
        partdescription: new FormControl({value: '', disabled: false},[]),
        createasproduct: new FormControl({value: false, disabled: false},[]),
        price: new FormControl({value: '', disabled: false},[]),
        productdetails: new FormControl({value: '', disabled: false},[]),
        id:  new FormControl(0,[]),
      })

    }


    if (this.master){

      let info = {
        method: 'Get_VendorsMasterCompactList'
      }
  
      this.MapInformationService.MethodCallApiFlex(info).subscribe(resp => {
        this.dataManufactured = resp
        console.log("🚀 ~ NewPartComponent ~ this.MapInformationService.MethodCallApiFlex ~ this.dataManufactured:", this.dataManufactured)
      })

      console.log(this.formDataParts)
      if(this.formDataParts == undefined){
        this.newPart = new FormGroup({
          partnumber: new FormControl({value: '', disabled: false},[]),
          parttypeid: new FormControl({value: '', disabled: false},[]),
          manufacturedid: new FormControl({value: '', disabled: false},[]),
          defaultvendorid: new FormControl({ value: null, disabled: false }, []),
          stdcost: new FormControl({value: '', disabled: false},[]),
          active: new FormControl({value: true, disabled: false},[]),
          taxable: new FormControl({value: '', disabled: false},[]),
          partdescription: new FormControl({value: '', disabled: false},[]),
          createasproduct: new FormControl({value: false, disabled: false},[]),
          price: new FormControl({value: '', disabled: false},[]),
          productdetails: new FormControl({value: '', disabled: false},[]),
          id:  new FormControl(0,[]),
        })
      } else {
        this.newPart = new FormGroup({
          partnumber: new FormControl({value:this.formDataParts.partnumber, disabled: false},[]),
          parttypeid: new FormControl({value:this.formDataParts.parttypeid, disabled: false},[]),
          manufacturedid: new FormControl({value:this.formDataParts.manufacturedid, disabled: false},[]),
          defaultvendorid: new FormControl({ value: this.formDataParts.defaultvendorid != null ? this.formDataParts.defaultvendorid : null, disabled: false }, []),
          stdcost: new FormControl({value:this.formDataParts.stdcost, disabled: false},[]),
          active: new FormControl({value:this.formDataParts.active == undefined ? false:true, disabled: false},[]),
          taxable: new FormControl({value:this.formDataParts.taxable == undefined ? false:true, disabled: false},[]),
          partdescription: new FormControl({value:this.formDataParts.partdescription, disabled: false},[]),
          createasproduct: new FormControl({value:this.formDataParts.createasproducte, disabled: false},[]),
          price: new FormControl({value:this.formDataParts.price, disabled: false},[]),
          productdetails: new FormControl({value:this.formDataParts.productdetails, disabled: false},[]),
          id:  new FormControl(this.formDataParts.id,[])
        })
      }
    }
    this.disableproductinput = true;
    this.partService.GetPartType().subscribe(result=>{
      console.log("🚀 ~ file: new-part.component.ts:93 ~ NewPartComponent ~ this.partService.GetPartType ~ result:", result)
      this.parttype = result;
    })
  }

  createproduct(){
    this.disableproductinput = !this.disableproductinput;
    if(this.disableproductinput==true){
      this.newPart.get('price').setValue('');
      this.newPart.get('productdetails').setValue('');
    }
  }

  async savePart(edit){
    let ParNumberDupli = false
    let form = this.newPart.value;
    if (this.master){
      form.method = 'InsertUpdate_AcctPartsMasterCE';
    } else {
      form.method = 'InsertUpdate_AcctPartsCE';
    }
    form.active = form.active == true ? 1 : 0;
    form.taxable = form.taxable == true ? 1 : 0;
    form.isvale = 0;
    console.log(form);
    let consultarNumber = {method: 'Get_PartsALlByPartNumber', partnumber: form.partnumber}
    await this.MapInformationService.SaveInfoSites(consultarNumber).subscribe(async res => {
      let respuesta = res
      await respuesta.forEach(element => {
        if(element.NUM === form.partnumber){
          ParNumberDupli = true
          this.toast.error('The part number is already registered, please verify.');
        }
      });
      if(ParNumberDupli === false){
        this.partService.InsertUpdate(form).subscribe(result=>{
          form.idNewPart = result[0].ResultID
          this.toast.success(this.translate.instant('msgPartInfUpdSucc'));
          this.popupNewPart = false;
          console.log(result);
          if(edit=='edit'){
            console.log(result);
            this.route.navigate(['parts/editParts'], {
              queryParams: {
                numID: result[0].ResultID
              }
            });
          }else{
            this.initForm();
            this.onsubmit.emit(form);
          }
        })
      }
    })
  }

  closepopup(){
    this.popupNewPart = false;
    this.initForm()
    this.onmodalhidden.emit();
  }

  validateDescription(e){
    console.log(e);
    console.log(e.value.length)
    if(e.value.length>1000){
      this.errorDescription = true;
    }else{
      this.errorDescription = false;
    }
  }





  openAlps(){
    this.popupAPL = true;
  }


  closePopups() {
    this.popupAPL = false;
    this.popupPartsSearch = false;
  }

  resultData(data){
    console.log("aqui")
    this.popupAPL = false;
    this.popupPartsSearch = false;

    console.log(data)

    let form = {
      partnumber:data.partnumber,
      idNewPart:data.partid,
      price:data.listprice,
      PartId:data.partid,
      partdescription:data.partdescription,

    }

    this.onsubmit.emit(form)
  }
  CloseImportMaster(data){
    console.log(data)
  }

}
function patchValue(arg0: { partnumber: any; parttypeid: any; stdcost: any; active: any; taxable: any; partdescription: any; createasproduct: any; price: any; productdetails: any; id: any; }): FormGroup {
  throw new Error('Function not implemented.');
}


